import { Component, computed, HostListener, inject, input } from '@angular/core';
import { Checkbox } from '../checkbox/checkbox';
import { CheckboxLabel } from '../checkbox-label/checkbox-label';
import { NgClass } from '@angular/common';
import { CheckboxGroup } from '../checkbox-group/checkbox-group';

@Component({
  imports: [Checkbox, CheckboxLabel, NgClass],
  selector: 'ui-checkbox-group-option',
  templateUrl: './checkbox-group-option.html',
})
export class CheckboxGroupOption {
  private checkboxGroup = inject(CheckboxGroup);

  value = input.required<string>();
  disabled = input<boolean>(false);

  protected selected = computed(() => {
    const value = this.value();
    return this.checkboxGroup.value().includes(value);
  });
  protected isDisabled = computed(() => this.disabled() || this.checkboxGroup.disabled());

  @HostListener('click', ['$event'])
  protected onClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.isDisabled()) {
      return;
    }
    const checked = this.selected();
    if (checked) {
      this.checkboxGroup.onUncheckOption(this.value());
    } else {
      this.checkboxGroup.onCheckOption(this.value());
    }
  }
}
